const TICKET = 'TICKET'
const A4 = 'A4'

const __dictionary = {
  [TICKET]: {
    id: TICKET,
    nombre: 'TICKET'
  },
  [A4]: {
    id: A4,
    nombre: 'A4'
  }
}

const __array = [__dictionary[TICKET], __dictionary[A4]]

export default Object.freeze({
  TICKET,
  A4,
  __dictionary,
  __array
})

